import { basketsGQLQuery, billingDetailsGQLQuery, invoicesGQLQuery, purchaseGQLMutation, updateBillingDetailsGQLMutation, vatTypesGQLQuery, } from '../../graphql/index.js';
export class BillingClient {
    constructor(client) {
        this.client = client;
    }
    async details(accessToken) {
        const result = await this.client.authorizedRequest({
            query: billingDetailsGQLQuery(),
            customToken: accessToken,
        });
        return result.billingDetails;
    }
    async invoices(accessToken) {
        const result = await this.client.authorizedRequest({
            query: invoicesGQLQuery(),
            customToken: accessToken,
        });
        return result.invoices;
    }
    async vatTypes(accessToken) {
        const result = await this.client.authorizedRequest({
            query: vatTypesGQLQuery(),
            customToken: accessToken,
        });
        return result.vatTypes;
    }
    async purchase(variables, accessToken) {
        const result = await this.client.authorizedRequest({
            query: purchaseGQLMutation(),
            variables,
            customToken: accessToken,
        });
        return result.purchase;
    }
    async updateDetails(variables, accessToken) {
        const result = await this.client.authorizedRequest({
            query: updateBillingDetailsGQLMutation(),
            variables,
            customToken: accessToken,
        });
        return result.updateBillingDetails;
    }
    async baskets(variables, accessToken) {
        const result = await this.client.authorizedRequest({
            query: basketsGQLQuery(),
            variables,
            customToken: accessToken,
        });
        return result.baskets;
    }
}
//# sourceMappingURL=billing.client.js.map